import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { BrandColors } from '../../../../constants/brandColors';
import { TaskListProgressBarStyleConfig } from '../../../interfaces';

export const TaskListProgressBarStyles = makeStyles<TaskListProgressBarStyleConfig>()((theme: Theme, props) => ({
  progressBullets: {
    position: 'fixed',
    left: 20,
    top: '50%',
    transform: 'translateY(-50%)',
    listStyle: 'none',
    padding: '0 16px',
    fontSize: 0,
    border: `2px solid ${props.outlineColor}`, //border color of the tasklistprogressbar
    backgroundColor: `${props.fillColor}`, //backgournd color of the tasklistprogressbar
    borderRadius: 60,
    boxShadow: `5px 5px 5px 0 rgba(91, 103, 112, 0.05)`,
  },
  innerCircleFilled: {
    width: '18px',
    height: '18px',
    margin: '20px 0',
    padding: '5px',
    boxShadow: `2px 1px 5px 0 rgba(0, 0, 0, 0.1)`,
    border: `solid 2px ${props.dotColor}`, //border color of the inner dot
    position: 'relative',
    display: 'block',
    borderRadius: '50%',
    '&:before': {
      content: '""',
      position: 'absolute',
      left: '3px',
      top: '3px',
      width: '8px',
      height: '8px',
      backgroundColor: `${props.dotColor}`, //inner dot color of the circle
      borderRadius: '50%',
    },
  },
  circleFilled: {
    display: 'block',
    width: '18px',
    height: '18px',
    margin: '20px 0',
    boxShadow: `2px 1px 5px 0 rgba(0, 0, 0, 0.1)`,
    border: `solid 2px ${props.dotColor}`, //color of the border of the circle which is filled
    backgroundColor: `${props.dotColor}`, //filled circle background color/fill color of the cirlce
    borderRadius: '50%',
  },
  circleUnfilled: {
    //props: TaskListProgressBarStyleConfig
    display: 'block',
    width: '18px',
    height: '18px',
    margin: '20px 0',
    boxShadow: `2px 1px 5px 0 rgba(0, 0, 0, 0.1)`,
    border: `solid 2px ${BrandColors.grey89}`, //color of the border of the unfilled circle
    borderRadius: '50%',
  },
  progressBar: {},
  temporary: {
    temp: theme.typography.fontSize, //added to avoid unused import lint error, as the vaiable may be used later
  },
}));
